function shuffle(array: Array<any>) {
  let counter = array.length
  while (counter > 0) {
    let index = Math.floor(Math.random() * counter)
    counter--
    let temp = array[counter]
    array[counter] = array[index]
    array[index] = temp
  }
  return array
}

export const palette = shuffle([
  '#e3b5ed',
  '#b842b7',
  '#784a95',
  '#8475cf',
  '#4247a7',
  '#169cc4',
  '#295877',
  '#50d0bd',
  '#9deaf0',
  '#26a778',
  '#a6fa89',
  '#daf06c',
  '#bad337',
])
